/**
 * The single list of tests a batch can be raised for.
 *
 * This list was hard-coded as JSX in seven places across four files and had
 * drifted apart: only the Test Request Form offered "R&D Identification Test"
 * and "Retest", the other five live copies offered two options, and none offered
 * "Resampling". A batch created from the MRN screen could therefore never be
 * given a test that the TRF screen considered valid.
 *
 * The values are stored verbatim in batch_details.test_to_be_performed and, per
 * cycle, in test_request_forms.test_requested, so they are data - do not rename
 * an existing one. In production: Complete Analysis 10,479 · Identification Test
 * 52 · Retest 3.
 *
 * Nothing branches on these strings anywhere in either repo; they are labels that
 * travel through to the printed TRF. Adding a value is therefore safe, which is
 * why "Resampling" can simply be appended.
 */
export const TEST_TO_BE_PERFORMED_OPTIONS = [
  'Identification Test',
  'Complete Analysis',
  'R&D Identification Test',
  'Retest',
  'Resampling'
];

export default TEST_TO_BE_PERFORMED_OPTIONS;
